import React from 'react';
import { Container } from '../helpers/Grid';
import { Image, UnderlineTitle } from '../common';
import SponsorsProps from './type';
import './styles.scss';

const Sponsors = ({
  title,
  sponsors,
}: SponsorsProps) => (
  <div className="sponsors">
    <Container>
      <UnderlineTitle title={title} containerTheme="white" />

      <ul className="sponsors__list">
        {sponsors.map(({ logo, link }) => (
          <li key={logo.title} className="sponsors__item">
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a
              className="sponsors__link"
              href={link.url}
              target={link.isExternal ? '_blank' : '_self'}
              rel={link.isExternal ? 'noopener noreferrer' : ''}
            >
              <Image url={logo.file.url} alt={logo.title} aspectRatio="1x1" />
            </a>
          </li>
        ))}
      </ul>
    </Container>
  </div>
);

export default Sponsors;
